'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*

  Declare and export all DOM strings here

  e.g.

  export default {
    inlineCart: '[data-inline-cart]',
    inlineCartContents: '[data-inline-cart-contents]',
  };

  Usage:

  import dom from 'common/Dom';
  import { getCartContents } from './handlers';

  $(dom.inlineCartContents).html(getCartContents());

*/
var dom = {
  body: 'body',

  // Active Classes
  active: 'active',
  isActive: '.is-active',
  isActiveSelector: '.is-active',
  isActiveClassName: 'is-active',
  cartIsActive: 'cart-is-active',

  // Overlay
  overlay: '[data-overlay]',

  // Toggle
  toggle: '[data-toggle]',

  // Modal
  modal: '[data-modal]',
  openModal: '[data-open-modal]',
  closeModal: '[data-close-modal]',
  toggleModal: '[data-toggle-modal]',
  modalContents: '[data-modal-contents]',

  // Inline Cart
  cartFull: '[data-full-cart]',
  cartEmpty: '[data-empty-cart]',
  cartItemCount: '[data-item-count]',
  inlineCart: '[data-inline-cart]',
  lineItemKey: '[data-line-item-key]',
  cartAccountInline: '[data-account-inline]',
  cartAccountDrawer: '[data-account-drawer]',
  cartShippingHeader: '[data-shipping-header]',
  mobileCartIcon: '[data-mobile-cart-icon]',
  closeInlineCart: '[data-close-inline-cart]',
  toggleInlineCart: '[data-toggle-inline-cart]',
  inlineCartSubtotal: '[data-inline-cart-subtotal]',
  inlineCartContents: '[data-inline-cart-contents]',
  mobileCartCloseIcon: '[data-mobile-cart-close-icon]',
  getFreeGiftBoxCheckbox: '[data-get-free-gift-box]',

  guestCheckoutLink: '[data-guest-checkout-link]',
  inlineCartCheckoutGuest: '[data-checkout-path]#checkoutGuest',
  inlineCartCheckoutAccount: '[data-checkout-path]#checkoutAccount',
  inlineCartCheckoutFormSignIn: '#inline-cart #customer_login',
  inlineCartCheckoutFormCreate: '#inline-cart #create_customer',

  inlineCartAccountButtons: '[data-inline-account-buttons]',
  lineItemOverlay: '[data-line-item-overlay]',

  // Collection
  collectionSwatch: '[data-collection-swatch]',

  // Containers
  container: '[data-container]',
  sliderContainer: '[data-container="slider"]',
  productContainer: '[data-container="product"]',

  // JSON Data
  imageData: '[data-from-shopify="image"]',
  optionData: '[data-from-shopify="option"]',
  shopifyData: '[data-from-shopify]',
  productData: '[data-from-shopify="product"]',
  variantData: '[data-from-shopify="variant"]',
  lineItemData: '[data-from-shopify="line-item"]',

  // Cart Controls
  addToCart: '[data-add-to-cart]',
  optionValue: '[data-option-value]',
  quantityValue: '[data-quantity-value]',
  quantityChange: '[data-quantity-change]',
  removeFromCart: '[data-remove-from-cart]',
  selectedOptionValue: '[data-selected-option-value]',

  // Price
  price: '[data-product-pricing] .money',
  compareAtPrice: '[data-compare-price] .money',

  // Slider
  sliderHasNav: '[data-has-nav]',
  galleryThumb: '[data-gallery-thumb]',
  gallerySlide: '[data-gallery-slide]',
  sliderFilterValue: '[data-filter-value]',
  productGallerySlide: '[data-product-gallery-slide]',

  // Vendor
  selectizeInput: '.selectize-control.single .selectize-input',
  selectizeInputInput: '.selectize-control.single .selectize-input input',

  // OLD
  // Mega Menu
  mainMenuItem: '[data-menu-section]',
  megaMenuLink: '[data-menu-link-id]',
  megaMenuTiles: '[data-menu-tiles-id]',

  // Accordion Menu
  accordionBlock: '[data-accordion-block]',
  accordionClick: '[data-accordion-click]',
  accordionContent: '[data-accordion-content]',

  // FAQ
  faqMenu: '[data-faq-menu]',
  faqMenuBtn: '[data-faq-menu-btn]',
  faqMenuClose: '[data-close-faq-menu]',
  faqNewsletter: '[data-faq-newsletter]',
  faqNav: '[data-faq-control-bar]',
  faqHelpBox: '[data-faq-helpbox]',

  // Strap Guide
  watchSlider: '[data-strap-guide-watch-tiles]',
  watchTile: $('[data-strap-guide-watch-tile]'),
  strapCollectionEntry: $('[data-strap-collection-entry]'),
  strapGuideHeader: $('[data-strap-guide-header]'),

  // PDP Tab Section
  pdpTabButton: '[data-product-tab-btn]',
  pdpTabContent: '[data-product-tab-content]',
  pdpAccordionHead: '[data-product-accordion-head]',
  pdpAccordionContent: '[data-product-accordion-content]',

  // PDP Top Section
  pdpReviewTop: '[data-product-review-top]',
  pdpImageGallery: '[data-product-gallery]',
  pdpImageNav: '[data-product-gallery-nav]',
  pdpVariantOptionsEntry: '[data-product-variant-options-entry]',
  pdpVideo: '[data-product-video]',
  pdpUpsellsWrapper: '[data-product-upsells-wrapper]',
  pdpUpsells: '[data-product-upsells]',
  pdpUpsell: '[data-product-upsell]',
  pdpUpsellCheckbox: '[data-upsell-checkbox]',
  pdpSwellPoints: '[data-product-swell-points]',
  pdpOptions: '[data-product-options]',
  pdpOptionsGroup: '[data-option-group]',
  pdpOption: '[data-option-value]',
  pdpOptionValue: '[data-product-value]',
  pdpVariantValue: '[data-variant-value]',

  // shop insta
  shopInstaMenu: '[data-shop-insta-menu]',
  shopInstaMenuBtn: '[data-shop-insta-menu-btn]',
  shopInstaMenuClose: '[data-shop-insta-close-menu]',
  shopInstaNewsletter: '[data-shop-insta-newsletter]',
  shopInstaSignupSuccess: '[data-shop-insta-signup-success]',
  shopInstaNav: '[data-shop-insta-control-bar]',

  // account
  formInput: '[data-form-input]',
  formTextarea: '[data-form-textarea]',
  formSwap: '[data-js-form-swap]',
  addAddress: '[data-add-address]',
  login: '[data-login-container]',
  forgotPass: '[data-forgot-password-container]',
  resetSuccess: '[data-password-reset-success]',

  accountMenu: '[data-account-menu]',
  accountMenuBtn: '[data-account-menu-btn]',
  accountMenuClose: '[data-close-account-menu]',
  accountNewsletter: '[data-account-newsletter]',
  accountNav: '[data-account-control-bar]',
  hideTopBar: '[data-hide-top-bar]',

  // blog
  blogMenu: '[data-blog-menu]',
  blogMenuBtn: '[data-blog-menu-btn]',
  blogMenuClose: '[data-close-blog-menu]',
  blogNewsletter: '[data-blog-newsletter]',
  blogSignupSuccess: '[data-blog-signup-success]',
  blogNav: '[data-blog-control-bar]',

  // bis
  bis: '[data-bis]',
  bisVariantInput: '[data-bis-variant-id]',
  bisToggle: '[data-trigger-bis]',

  // misc.
  gridItemInfoLink: '[data-grid-item-info-link]',
  selectForm: '[data-form-group-select]',
  slider: '[data-slider]',
  addToCartText: '[data-add-to-cart-text]',
  openQuickshop: '[data-open-quickshop]',
  portal: '[data-portal]',
  klarnaPlacement: '[data-klarna-placement]'
};

exports.default = dom;